import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import List, { ListItem, ListItemText } from 'material-ui/List';

import MicrostripParams from './MicrostripParams';
import EmbeddedMicrostripParams from './EmbeddedMicrostripParams';
import StriplineParams from './StriplineParams';
import AsymmetricStriplineParams from './AsymmetricStriplineParams';
import {
  MICROSTRIP,
  EMBEDDED_MICROSTRIP,
  STRIPLINE,
  ASYMMETRIC_STRIPLINE
  
} from '../../../../../../constants/globals';

function findParamsComponent(simulationModel) {
  switch (simulationModel) {
    case MICROSTRIP:
      return MicrostripParams;
    case EMBEDDED_MICROSTRIP:
      return EmbeddedMicrostripParams;
    case STRIPLINE:
      return StriplineParams;
    case ASYMMETRIC_STRIPLINE:
      return AsymmetricStriplineParams;
    default: 
      return null;
  }
}

export function ParamsList({
  classes,
  simulationModel,
  frequency,
  params,
  lengthUnit
}) {
  const ParamsComponent = findParamsComponent(simulationModel);

  return (
    <List>
      <ListItem>
        <Avatar className={classes.paramsAvatar}>
          Hz 
        </Avatar>
        <ListItemText>
          {frequency}
        </ListItemText>
      </ListItem>
      {ParamsComponent &&
        <ParamsComponent params={params} classes={classes} lengthUnit={lengthUnit} />}
    </List>
  )
}

ParamsList.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  simulationModel: PropTypes.string,
  frequency: PropTypes.string,
  params: PropTypes.shape({
    thickness: PropTypes.number,
    transmissionWidth: PropTypes.number,
    transmissionSpacing: PropTypes.number,
    dielectricUpHeight: PropTypes.number,
    dielectricDownHeight: PropTypes.number,
    dk: PropTypes.number
  }),
  lengthUnit: PropTypes.string.isRequired,
};

ParamsList.defaultProps = {
  simulationModel: '',
  frequency: '',
  params: {}
}

export default ParamsList;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/SimulationModelModal/ParamsList/ParamsList.jsx